._footer_oe3rm_1 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  height: 100%; }

._footerLink_oe3rm_8 {
  width: 50%; }
